import axios, { AxiosInstance } from 'axios';
import LocalStorage from './localstorage';

const URL = 'https://staging.eye.guide';
const storage = new LocalStorage();
const HTTP_OK = 200;

export default class DataService {
    
    _instance: AxiosInstance;

    constructor() {
        this._instance = this.createInstance();
    }
    
    async uploadFile(file: any, rosterid: string, rostername: string) {
        let o = {
                query: `mutation ($file: Upload!, $rosterid: String, $rostername: String) {
                            uploadProfiles (file: $file, rosterid: $rosterid, rostername: $rostername){
                                            message 
                                            status
                            }
                        }`,
                variables: {
                    file,
                    rosterid,
                    rostername
                }
        };
        let map = {
            '0': ['variables.file']
        };

        let fd = new FormData();
        fd.append('operations', JSON.stringify(o));
        fd.append('map', JSON.stringify(map));
        fd.append('0', file, 'app.js');
        const token = storage.getToken(); 
        if (token.length === 0) {
            return;
        }
        let res = await this._instance.post(URL + '/graphql', fd, {
                                        headers: {
                                            'x-authorization': 'Bearer ' + token,
                                            'content-type': 'multipart/form-data'
                                        }
                    });
        if (res.status === HTTP_OK) {
            return res.data.data.uploadProfiles;
        } else {
            return 'failed';
        }
    }

    async uploadOrganizations(file: any, primaryorganizationid: any) {
        let o = {
            query: `mutation ($file: Upload!, $primaryorganizationid: String) {
                        uploadOrganizations (file: $file,
                            primaryorganizationid: $primaryorganizationid) {
                                        message 
                                        status
                                        index
                        }
                    }`,
            variables: {
                file,
                primaryorganizationid
            }
        };
        let map = {
            '0': ['variables.file']
        };

        let fd = new FormData();
        fd.append('operations', JSON.stringify(o));
        fd.append('map', JSON.stringify(map));
        fd.append('0', file, 'app.js');
        const token = storage.getToken(); 
        if (token.length === 0) {
            return;
        }
        let res = await this._instance.post(URL + '/graphql', fd, {
                                        headers: {
                                            'x-authorization': 'Bearer ' + token,
                                            'content-type': 'multipart/form-data'
                                        }
                    });
        if (res.status === HTTP_OK) {
            return res.data.data.uploadOrganizations;
        } else {
            return 'failed';
        }
    }

    async uploadUsers(file: any, primaryorganizationid: any) {
        let o = {
            query: `mutation ($file: Upload!, $primaryorganizationid: String) {
                        uploadUsers (file: $file,
                            primaryorganizationid: $primaryorganizationid) {
                                        message 
                                        status
                                        index
                        }
                    }`,
            variables: {
                file,
                primaryorganizationid
            }
        };
        let map = {
            '0': ['variables.file']
        };

        let fd = new FormData();
        fd.append('operations', JSON.stringify(o));
        fd.append('map', JSON.stringify(map));
        fd.append('0', file, 'app.js');
        const token = storage.getToken(); 
        if (token.length === 0) {
            return;
        }
        let res = await this._instance.post(URL + '/graphql', fd, {
                                        headers: {
                                            'x-authorization': 'Bearer ' + token,
                                            'content-type': 'multipart/form-data'
                                        }
                    });
        if (res.status === HTTP_OK) {
            return res.data.data.uploadUsers;
        } else {
            return 'failed';
        }
    }

    async login(username: string, password: string) {
        let res = await this._instance.post('/graphql', {
                                                data: {
                                                    query : ` 
                                                        mutation {
                        Login(username:${JSON.stringify(username)}, password:${JSON.stringify(password)}) 
                                                                  {
                                                                      token
                                                                  }
                                                                }
                                                    `    
                                                }
                                            });
        if ( res.status === HTTP_OK) {
            return res.data;
        } else {
            throw new Error(res.statusText);
        }
    }

    createInstance() {
        return axios.create({
            baseURL: URL,
            timeout: 300000,
        });
    }
}


// WEBPACK FOOTER //
// ./src/service/data.service.ts